/* Carrousels SCZJ : uniquement utilisés par le brouillon ALUNERO V3. */
(function () {
  function setup(root) {
    var galleries = root.querySelectorAll ? root.querySelectorAll('[data-alunero-sczj-gallery]') : [];
    galleries.forEach(function (gallery) {
      if (gallery.dataset.galleryInitialized === 'true') return;
      gallery.dataset.galleryInitialized = 'true';
      var slides = Array.from(gallery.querySelectorAll('[data-alunero-sczj-slide]'));
      var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      var count = gallery.querySelector('[data-alunero-gallery-count]');
      if (!slides.length) return;
      var selected = 0;
      var render = function (index) {
        selected = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.hidden = i !== selected; });
        thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-pressed', i === selected ? 'true' : 'false'); });
        if (count) count.textContent = (selected + 1) + ' / ' + slides.length;
      };
      gallery.querySelectorAll('[data-gallery-shift]').forEach(function (button) {
        button.addEventListener('click', function () { render(selected + Number(button.dataset.galleryShift)); });
      });
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { render(i); });
      });
      var frame = gallery.querySelector('.alunero-sczj-gallery__frame');
      if (frame) {
        frame.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); render(selected + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); render(selected - 1); }
        });
        var x = null;
        frame.addEventListener('touchstart', function (event) { x = event.touches.length === 1 ? event.touches[0].clientX : null; }, { passive: true });
        frame.addEventListener('touchend', function (event) {
          if (x === null || !event.changedTouches.length) return;
          var delta = event.changedTouches[0].clientX - x;
          x = null;
          if (Math.abs(delta) > 48) render(selected + (delta < 0 ? 1 : -1));
        }, { passive: true });
      }
      render(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(document); });
  else setup(document);
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();